"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEARCH_DOCUMENTS = exports.BULK_DELETE_DOCUMENTS = exports.BULK_EDIT_DOCUMENTS = exports.EDIT_DOCUMENT = exports.BULK_ADD_DOCUMENTS = exports.ADD_DOCUMENT = exports.DELETE_COLLECTION = exports.EDIT_COLLECTION = exports.LIST_COLLECTIONS = exports.CREATE_COLLECTION = exports.EXPORT_COLLECTIONS = exports.PARTIAL_UPDATE = void 0;
var DATASTORES_V1_BASE_URL = '/domo/datastores/v1/';
var DATASTORES_COLLECTIONS_URL = DATASTORES_V1_BASE_URL.concat('collections/');
var SINGLE_COLLECTION_DATASTORES_URL = function (collection) {
    return DATASTORES_COLLECTIONS_URL.concat(collection);
};
var DATASTORES_DOCUMENTS_URL = function (collection) {
    return SINGLE_COLLECTION_DATASTORES_URL(collection).concat('/documents/');
};
var PARTIAL_DOCUMENT_UPDATE_URL = function (collection) {
    return DATASTORES_DOCUMENTS_URL(collection).concat('update');
};
var EXPORT_URL = DATASTORES_V1_BASE_URL.concat('export');
exports.PARTIAL_UPDATE = PARTIAL_DOCUMENT_UPDATE_URL;
var BULK_DOCUMENTS_URL = function (collection) {
    return DATASTORES_DOCUMENTS_URL(collection).concat('bulk');
};
var SINGLE_DOCUMENT_URL = function (collection, document) {
    return DATASTORES_DOCUMENTS_URL(collection).concat(document);
};
var DOCUMENT_QUERY_URL = function (collection) {
    return DATASTORES_DOCUMENTS_URL(collection).concat('query');
};
exports.EXPORT_COLLECTIONS = EXPORT_URL;
exports.CREATE_COLLECTION = DATASTORES_COLLECTIONS_URL;
exports.LIST_COLLECTIONS = DATASTORES_COLLECTIONS_URL;
exports.EDIT_COLLECTION = SINGLE_COLLECTION_DATASTORES_URL;
var DELETE_COLLECTION = function (collection) {
    return DATASTORES_COLLECTIONS_URL.concat(collection);
};
exports.DELETE_COLLECTION = DELETE_COLLECTION;
exports.ADD_DOCUMENT = DATASTORES_DOCUMENTS_URL;
exports.BULK_ADD_DOCUMENTS = BULK_DOCUMENTS_URL;
exports.EDIT_DOCUMENT = SINGLE_DOCUMENT_URL;
exports.BULK_EDIT_DOCUMENTS = BULK_DOCUMENTS_URL;
var BULK_DELETE_DOCUMENTS = function (collection, documents) {
    return BULK_DOCUMENTS_URL(collection).concat("?ids=".concat(documents.map(encodeURIComponent).join(',')));
};
exports.BULK_DELETE_DOCUMENTS = BULK_DELETE_DOCUMENTS;
exports.SEARCH_DOCUMENTS = DOCUMENT_QUERY_URL;
